/**
 * Back to Top and Edit Post button
 *
 * Hide or display the action buttons on scroll.
 */
export default function initScrollTop() {

    var scrollLastPos = 0;

    jQuery(window).scroll(function (event) {

        var scrollTopCurrent = jQuery(this).scrollTop();
        var scrollOffset = 200;
        var btnToTop = jQuery('.--to-top');
        var btnEditPost = jQuery('.--edit-post-link');

        if (scrollTopCurrent > scrollOffset) {

            if (scrollTopCurrent > scrollLastPos) {
                btnToTop.removeClass('anim-up').addClass('anim-up-reverse');
                btnEditPost.removeClass('anim-up2').addClass('anim-up2-reverse');
            } else {
                btnToTop.removeClass('anim-hide').removeClass('anim-up-reverse').addClass('anim-up');
                btnEditPost.removeClass('anim-hide').removeClass('anim-up2-reverse').addClass('anim-up2');
            }

        } else if (scrollTopCurrent < scrollOffset) {

            btnToTop.addClass('anim-up-reverse');
            btnEditPost.addClass('anim-up2-reverse');

        }

        scrollLastPos = scrollTopCurrent;

    });
}